import {unauthenticate} from "@onflow/fcl"

export const LABEL = "Log Out"
export const CMD = unauthenticate
